var map = {
	"./AirFryerGarlicCheeseBread_1x1.png": 9697,
	"./AirFryerGarlicCheeseBread_2x3.png": 1499,
	"./AirFryerGarlicCheeseBread_3x2.png": 6515,
	"./AirFryerGarlicCheeseBread_9x16.png": 8789,
	"./EggsBreakfastSalad_1x1.png": 8452,
	"./EggsBreakfastSalad_2x3.png": 6149,
	"./EggsBreakfastSalad_3x2.png.jpg": 4212,
	"./FriedFishInSauce.jpg": 3368,
	"./FriedRice.jpg": 357,
	"./HomemadeChickenTenders_1x1.png": 2309,
	"./HomemadeChickenTenders_2x3.png": 7969,
	"./HomemadeChickenTenders_3x2.png": 7420,
	"./HomemadeChickenTenders_9x16.png": 363,
	"./Logo-Black-600px.png": 9756,
	"./Logo-Dark-600px.png": 1974,
	"./Logo-Dark-60px.png": 2705,
	"./Logo-Light-600px.png": 3868,
	"./MainLogo_BU.png": 3822,
	"./MainLogo_Dark-100px.png": 3411,
	"./MainLogo_Dark-200px.png": 3567,
	"./MainLogo_Dark.png": 3746,
	"./MainLogo_Light.png": 7935,
	"./MangoWithStickyRice.jpg": 906,
	"./RecipePostThumbnail/RecipePostThumbnail": 6395,
	"./RecipePostThumbnail/RecipePostThumbnail.js": 6395,
	"./RecipePostThumbnail/Sausage": 4384,
	"./RecipePostThumbnail/Sausage.js": 4384,
	"./RotiWIthBananaAndChocolate.jpg": 7385,
	"./Strawberry-BananaHoneyMilkshakeSmoothie_1x1.png": 5705,
	"./Strawberry-BananaHoneyMilkshakeSmoothie_2x3.png": 427,
	"./Strawberry-BananaHoneyMilkshakeSmoothie_3x2.png": 8150,
	"./Strawberry-BananaHoneyMilkshakeSmoothie_9x16.png": 1462,
	"./ThaiBasilwithBeef_1x1.png": 7564,
	"./ThaiBasilwithBeef_2x3.png": 9159,
	"./ThaiBasilwithBeef_3x4.png": 1620,
	"./ThaiBasilwithBeef_9x16.png": 2925,
	"./ThaiMangoSalad_1x1.png": 4191,
	"./ThaiMangoSalad_2x3.png": 7666,
	"./ThaiRicePorridgewithFish_1x1.png": 7452,
	"./ThaiRicePorridgewithFish_2x3.png": 5593,
	"./ThaiRicePorridgewithFish_3x2.png": 9524,
	"./ThaiRicePorridgewithFish_9x16.png": 7809,
	"./VanillaBerrySmoothie_1x1.png": 6022,
	"./VanillaBerrySmoothie_2x3.png": 3427,
	"./YouTubeThumbnail/Fish": 3425,
	"./YouTubeThumbnail/Fish.js": 3425,
	"./YouTubeThumbnail/YouTubeThumbnail": 2286,
	"./YouTubeThumbnail/YouTubeThumbnail.js": 2286,
	"./base64Images/base64Images/base64Images": 408,
	"./base64Images/base64Images/base64Images.js": 408,
	"./blackFill-myFoodieLogoSVG.svg": 42,
	"./cursors/eyeCursor.cur": 8075,
	"./cursors/eyeCursorDark.svg": 6074,
	"./cursors/eyeCursorLight.svg": 7008,
	"./cursors/eyeCursorLight_OLD.svg": 387,
	"./cursors/zoom_in.cur": 5979,
	"./icons/svgIcons": 9433,
	"./icons/svgIcons.js": 9433,
	"./red-heart_2764-fe0f.png": 453,
	"./thums-up-solid.svg": 7515,
	"./whiteFill-myFoodieLogoSVG.svg": 8709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;